import {getProductSku} from "@/components/core/products/Product";

const state = {};

const getters = {
	/**
	 * Retrieves a dictionary of products organized by their SKU. Each product object includes its associated block data.
	 *
	 * @param {Object} state - The current state of the module.
	 * @param {Object} getters - The module's getters.
	 * @param {Object} rootState - The root state of the store.
	 * @param {Object} rootGetters - The root getters, including the `filterableItems`.
	 * @return {Object} A dictionary where the keys are product SKUs and the values are product objects with additional block data.
	 */
	productsBySKU(state, getters, rootState, rootGetters){
		const o = {};
		rootGetters.filterableItems.forEach((block) => {
			block.products.forEach((prod) => {
				const sku = getProductSku(prod);
				if(sku)o[sku] = {...prod, blockData: block};
			})
		})
		return o;
	}
}

const actions = {
	/**
	 * A valid product contains a sku that is shoppable
	 * @param param0
	 * @param param0.getters
	 * @param product
	 * @returns {boolean}
	 */
	isValidProduct({getters}, product) {
		const sku = getProductSku(product);
		//console.log('!!!!!!isValidProduct:', sku);
		return !!getters.productsBySKU[sku];
	}
}


export default {
	namespaced: true,
	state,
	getters,
	actions
};
